import React, { createContext, useContext, useState } from "react";

const DomainContext = createContext<any>(null);

export const useDomainContext = () => useContext(DomainContext);

export const DomainProvider = ({ children }: { children: React.ReactNode }) => {
  const [domains, setDomains] = useState<any>([{}]);
  const [selectedDomain, setSelectedDomain] = useState<any>(null);
  const [selectedSubdomain, setSelectedSubdomain] = useState<any>(null);
  const [myParams, setMyParams] = useState<any>({did:1, sdid:1});
  const [collapsed, setCollapsed] = useState({});


  return (
    <DomainContext.Provider value={{
      domains,
      setDomains,
      selectedSubdomain,
      setSelectedSubdomain,
      myParams,
      setMyParams,
      collapsed,
      setCollapsed
    }}>
      {children}
    </DomainContext.Provider>
  );
};